import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './components/App.vue'
import Vuex from 'vuex'
import { store } from '../andromeda/store/store'

Vue.use(VueAxios, axios)
Vue.use(Vuex)

new Vue({
  el: '#BlogNoticias',
  delimiters: [ '[[', ']]' ],
  store,
  beforeMount () {
    this.$store.state.initials = Object.assign({}, this.$el.dataset)
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/modules/blog/ara/index.js